export interface Toast {
  message?: string;
  type?: ErrorVariants;
  canDisplay?: boolean;
  responseStatus?: string;
  position?: 'left' | 'right';
  toast?: boolean;
  msg?: string;
  toastType?: ToastType;
  title?: string;
}
export enum ErrorVariants {
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  NEUTRAL = 'NEUTRAL',
}

export enum ToastType {
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface TostMsg {
  toast: boolean;
  toastType: ToastType;
  msg: string;
  title: string;
}
